import { jsx as _jsx } from "react/jsx-runtime";
import withStyles from '../../core/withStyles';
import { preventDefault } from '../../helpers';
import Logo from '../Logo';
import styles from './MenuLogo.styles';
const isRenderFn = (value) => typeof value === 'function';
export const MenuLogo = ({ square = false, href, width, onClick, classes, children, }) => {
    if (isRenderFn(children)) {
        return children({
            className: classes.root,
            Logo: _jsx(Logo, { square: square, width: width }),
        });
    }
    return (_jsx("a", Object.assign({ href: href, onClick: preventDefault(onClick), className: classes.root }, { children: _jsx(Logo, { square: square, width: width }) })));
};
export default withStyles(styles)(MenuLogo);
//# sourceMappingURL=MenuLogo.js.map